
// export const logout = ( state ) => {
// }

export const setStaffers = (state, staffers) => {
    state.staffers = staffers
}

export const setStaffersSelectable = (state, staffers) => {
    state.staffersSelectable = staffers
}

export const setStaffersPaginated = (state, staffersPaginatedData) => {
    state.staffersPaginatedData = staffersPaginatedData
}

export const setStafferDetail = (state, staffer) => {
    state.staffer = staffer
}

export const saveNewStaffers = (state, staffer) => {
    state.staffers.unshift(staffer)
    state.createdData = staffer;
}

export const saveUpdatedStaffer = (state, staffer) => {
    state.staffers.unshift(staffer)
    state.updatedData = staffer;
}

export const setDeleteStaffer = (state, staffer) => {
    state.staffersPaginatedData.data.filter(x => x.id !== staffer.id);
    state.deletedData = staffer
}

export const setStafferIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setStafferIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setStafferIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setStafferIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
